import Vue from 'vue';
import Vuex from 'vuex';
// import user from './user';
import stone_app from '@/__vue2stone/store/app';
import stone_auth from '@/__vue2stone/store/auth';
import stone_locale from '@/__vue2stone/store/locale';
import app from './app';
import auth from './auth';
import model from './model';
import locale from './locale';
import snackbar from './snackbar';
import filesave from './filesave';
import updatepopup from './updatepopup';
import notification from './notification';
import error from './error';
import page from './page';
import sospopup from './sospopup';
import invalidpopup from './invalidpopup';
import downloadPopup from './downloadPopup';
import other from './other';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    // user: user,
    stone_app: stone_app,
    stone_auth: stone_auth,
    stone_locale: stone_locale,
    app: app,
    auth: auth,
    model: model,
    locale: locale,
    snackbar: snackbar,
    filesave: filesave,
    updatepopup: updatepopup,
    notification: notification,
    error: error,
    page: page,
    sospopup: sospopup,
    invalidpopup: invalidpopup,
    downloadPopup,
    other,
  },
});
